import FavoriteService from '@/services/FavoriteService'

const state = () => ({
  leagues: [],
  events: [],
  quantity: 0,

  prematch: {
    sports: [],
    loader: {
      top: true,
      loading: 0,
      scrollLoading: 0
    },
    screen: {
      top: 0,
      bottom: 0
    }
  },
  live: {
    sports: [],
    loader: {
      top: true,
      loading: 0,
      scrollLoading: 0
    },
    screen: {
      top: 0,
      bottom: 0
    },
    _factors: {}
  }
})

const getters = {}

const actions = {
  async CHECK ({ commit, state }) {
    if (!state.leagues.length && !state.events.length) {
      commit('CLEAR')
      return
    }
    try {
      const response = await FavoriteService.quantity({
        leagues: state.leagues,
        events: state.events
      })
      commit('APPLY', response.data)
    } catch (error) {
      console.log(error.response.data.error)
    }
  },
  async GET_OVERVIEW ({ commit, state }, { params, type, loader = true, scroll = false }) {
    if (!state.leagues.length && !state.events.length) {
      commit('CLEAR')
      return
    }
    if (loader) commit('INC' + (scroll ? '_SCROLL' : '') + '_LOADING', type)
    try {
      params.type = type
      params.leagues = state.leagues
      params.events = state.events
      if (type === 'live') {
        params.factors = state.live._factors
      }
      const response = await FavoriteService.overview(params)
      commit('SET_OVERVIEW', {
        type: type,
        data: response.data
      })
      if (loader) commit('DEC' + (scroll ? '_SCROLL' : '') + '_LOADING', type)
    } catch (error) {
      console.log(error.response.data.error)
    }
  }
}

const mutations = {
  CLEAR (state) {
    state.leagues = []
    state.events = []
    state.prematch.sports = []
    state.live.sports = []
    state.quantity = 0
  },
  TOGGLE_LEAGUE (state, league) {
    let ix = state.leagues.indexOf(league)
    if (ix !== -1) {
      state.leagues.splice(ix, 1)
      state.quantity--
    } else {
      state.leagues.splice(state.leagues.length, 0, league)
      state.quantity++
    }
  },
  TOGGLE_EVENT (state, event) {
    let ix = state.events.indexOf(event)
    if (ix !== -1) {
      state.events.splice(ix, 1)
      state.quantity--
    } else {
      state.events.splice(state.events.length, 0, event)
      state.quantity++
    }
  },
  APPLY (state, data) {
    for (let i in data.events) {
      let ix = state.events.indexOf(data.events[i])
      if (ix === -1) continue
      state.events.splice(ix, 1)
    }
    state.quantity = data.quantity
  },
  CLEAR_LOADING (state, type) {
    state[type].loader.loading = 0
    state[type].loader.scrollLoading = 0
  },
  INC_LOADING (state, type) {
    state[type].loader.loading++
  },
  DEC_LOADING (state, type) {
    state[type].loader.loading--
  },
  INC_SCROLL_LOADING (state, type) {
    state[type].loader.scrollLoading++
  },
  DEC_SCROLL_LOADING (state, type) {
    state[type].loader.scrollLoading--
  },
  SET_LOADER_POSITION (state, params) {
    state[params.type].loader.top = params.position !== 'bottom'
  },
  SET_OVERVIEW (state, params) {
    state[params.type].sports = params.data.sports.map(sport => {
      sport.group = 1
      return Object.assign({}, sport)
    })
    state[params.type].screen = Object.assign({}, params.data.screen)
    if (params.type === 'live') {
      state[params.type]._factors = params.data.factors
    }
  }
}

export default {
  namespaced: true,
  mutations,
  getters,
  actions,
  state
}



// WEBPACK FOOTER //
// ./src/store/modules/favorites.js